import { EngagementRate, Impressions, TweetCounter, EngagementRing } from './organisms'
import { iKpis, iData, iTweet } from '../Utils/Types'
import React from 'react'


const isYesterdayTweet = ({created_at}: {created_at:string}) => 
    parseDate(created_at) === parseDate(String(new Date(Number(new Date()) - 1000*24*60*60)))

const engagementRate = ({ Impressions, Likes, Visits, Replies, Retweets }: iKpis) =>
     Math.round(((Likes + Visits + Replies + Retweets )/Impressions)*1000)/10


const parseDate = (date: string) => `${new Date(date).getUTCDate()}-${new Date(date).getUTCMonth()}-${new Date(date).getUTCFullYear()}`
const dailyEngagement = (data: iData): {name: string, Engagement: number, text?:string }[] => data.tweets
    .filter(({ text }) => text[0] !== '@').filter((t) => isYesterdayTweet(t))
    .map(({ text, kpis }) => ({ name:'', Engagement: engagementRate(kpis), text: `${text.substring(0, 36)}...` }))
    .sort(() => -1)


const weeklyEngagement = (data: iData): {name: string, Engagement: number, text?:string }[] => data.kpis
    .sort(({ date:a }, { date:b }) => new Date(a) < new Date(b) ? -1 : 1)
    .map(({ kpis, date }) => ({ name: '', Engagement: engagementRate(kpis), text: date.substring(0, 10)}))

const visitorEngagement = (data: iData): {name: string, Engagement: number, text?:string }[] => data.tweets
    .map(({ text, kpis }) => ({ name:'', Engagement: engagementRate(kpis), text: `${text.substring(0, 36)}...` }))
    .sort(() => -1)


const engagementDetail = (tweets: iTweet[]) => [
    { name: 'Likes', value: tweets.reduce((d, { kpis }) => d += kpis.Likes, 0) },
    { name: 'Retweets', value: tweets.reduce((d, { kpis }) => d += kpis.Retweets, 0) },
    { name: 'Replies', value: tweets.reduce((d, { kpis }) => d += kpis.Replies, 0) },
    { name: 'Visits', value: tweets.reduce((d, { kpis }) => d += kpis.Visits, 0) }
]

const weeklyEngagementDetail = ({ kpis }: iData) => [
    { name: 'Likes', value: Math.round(kpis.reduce((d, { kpis }) => d += kpis.Likes, 0)/kpis.length) },
    { name: 'Retweets', value: Math.round(kpis.reduce((d, { kpis }) => d += kpis.Retweets, 0)/kpis.length) },
    { name: 'Replies', value: Math.round(kpis.reduce((d, { kpis }) => d += kpis.Replies, 0)/kpis.length) },
    { name: 'Visits', value: Math.round(kpis.reduce((d, { kpis }) => d += kpis.Visits, 0)/kpis.length) }
]


interface iKpi {data: iData, title: string, isWeekly?: boolean}
const YesterdayKPIs = ({ data, title }: iKpi) => <div className="column" style={{textAlign: 'center'}} >
    <p className="subtitle is-4" style={{color: 'white'}}> { title } </p>
    <EngagementRate data={dailyEngagement(data)}/>
    <TweetCounter 
        tweets={data.tweets.filter(t => isYesterdayTweet(t)).filter(({ text }) => text[0] !== '@').length} 
        replies={data.tweets.filter(t => isYesterdayTweet(t)).filter(({ text }) => text[0] === '@').length} 
    />

    <Impressions 
        tweets={
            data.tweets.filter(t => isYesterdayTweet(t))
            .filter(({ text }) => text[0] !== '@')
            .reduce((d, {kpis})=> d += kpis.Impressions,0)
        }
        total={
            data.tweets.filter(t => isYesterdayTweet(t))
            .reduce((d, {kpis})=> d += kpis.Impressions,0)
        } 
    />
    <EngagementRing data={engagementDetail(data.tweets.filter(t => isYesterdayTweet(t)))} />
</div>


const LastDaysKPIs = ({ data, title, isWeekly=false }: iKpi) => <div className="column" style={{textAlign: 'center'}} >
    <p className="subtitle is-4" style={{color: 'white'}}> { title } </p>
    <EngagementRate data={weeklyEngagement(data)}/>
    <TweetCounter 
        tweets={data.kpis.reduce((d, { kpis }) => d+=kpis.Tweets, 0)/data.kpis.length} 
        replies={data.kpis.reduce((d, { kpis }) => d+=kpis.Comments, 0)/data.kpis.length} 
    />

    <Impressions 
        isWeekly={true}
        tweets={data.kpis.reduce((d, { kpis }) => d+=kpis.Impressions, 0)/data.kpis.length} 
        total={Math.max(...data.kpis.map(({kpis})=> kpis.Impressions))} 
    />

    <EngagementRing data={weeklyEngagementDetail(data)} />
</div>


const VisitorKPIs = ({ data, title }: iKpi) => <div className="column" style={{textAlign: 'center'}} >
    <p className="subtitle is-4" style={{color: 'white'}}> { title } </p>
    <EngagementRate data={visitorEngagement(data)}/>
    <TweetCounter 
        tweets={data.tweets.filter(({ text }) => text[0] !== '@').length} 
        replies={data.tweets.filter(({ text }) => text[0] === '@').length} 
    />

    <Impressions 
        tweets={ data.tweets.filter(({ text }) => text[0] !== '@').reduce((d, {kpis})=> d += kpis.Impressions,0) }
        total={ data.tweets.reduce((d, {kpis})=> d += kpis.Impressions,0)} 
    />
    <EngagementRing data={engagementDetail(data.tweets)} />
</div>



export const KPI = ({ data }: {data: iData}) => <div className="columns">
    {
        data.paying
        ?   <>
            <YesterdayKPIs data={data} title={`Yesterday's KPIs`}/>
            <LastDaysKPIs data={data} title={'Last Days'} isWeekly={true}/>
        </>
        :   <VisitorKPIs data={data} title={`Recent Activity`}/>
    }
</div>
